module.exports = __webpack_public_path__ + "img/filter-test1.986b15b0.png";